<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="3">
        <h3>Filters</h3>
        <v-text-field
          v-model="tuneTitle"
          label="Tune title"
          clearable
        ></v-text-field>
        <v-switch
          v-model="hasRecordFilter"
          label="Only show tunes with available recordings"
        ></v-switch>
        <tuto-info>

          <h4 class="pa-2">Tunes</h4>
          <p class="pa-2">
            This <strong class="primary--text">Tunes</strong> page lists all of the tunes available on the site.
          </p>
          <p class="pa-2">
            You can <strong>Filter</strong> the available tunes.
          </p>
          <p class="pa-2">
            For example you can filter by <strong>Title</strong> or show <strong>only tunes that have recordings</strong>.
          </p>
          <p class="pa-2">
            You can come back here by clicking <strong class="primary--text">Tunes</strong> in
            <span class="overline primary--text">HOME > <span class="">TUNES</span></span>.
          </p>
        </tuto-info>
      </v-col>
      <v-col cols="12" md="6">
        <div class="overline ">
          <router-link class="primary--text" to="/home">home</router-link> >
          tunes
        </div>
        <h1 class="title-logo primary--text">Tunes</h1>
        <p>Showing {{ recFilteredTunes.length }} tunes</p>
        <v-row>
          <v-col cols="12" md="6" v-for="(tune, i) in recFilteredTunes" :key="i">
            <v-card class="" :to="'tunes/' + tune.id" :class="{ 'has-recording': tune.default_recording }">
              <v-card-title>
                {{ tune.title }}
              </v-card-title>
              <v-card-text>
                <h3>{{ tune.tune_type|capitalize }}</h3>
                <v-icon :color="tune.recordings.length ? 'primary' : 'grey lighten-2'">mdi-bookmark-music</v-icon>
                <span v-if="tune.recordings.length" class="font-weight-bold primary--text">
                  This tune has {{ tune.recordings.length }} recordings.
              </span>
              <span v-else>
                  No recordings for this tune yet...
              </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TutoInfo from '@/layout/TutoInfo.vue';

  // import TradPlayer from '@/components/TradPlayer'

  export default {
  name: 'TuneList',
  data: function () {
    return {
      playIndex: 0,
      tuneTitle: '',
      hasRecordFilter: false,
    }  
  },
  computed: {
    tunes: {
      get() {
        return this.$store.state.tune.tunes;
      }
    },
    recFilteredTunes() {
      if (!this.hasRecordFilter)
        return this.nameFilteredTunes
      else
        return this.nameFilteredTunes.filter(function (el) {
          if (el.default_recording)
            return el;
        });
    },
    nameFilteredTunes() {
      if (!this.tuneTitle || this.tuneTitle == '')
        return this.tunes;
      var vm = this;
      return this.tunes.filter(function (el) {
        if (el.title.toLowerCase().indexOf(vm.tuneTitle.toLowerCase()) > -1) {
          return el;
        }
      })
    },
    autoTunes() {
      if (!this.$store.state.tune.tunes.length)
        return []
      return this.$store.state.tune.tunes.map(
        function (tune) { return { text: tune.title, value: tune.id } })
    }

  },
  components: {
    // TradPlayer,
    TutoInfo
  },
  mounted() {
    this.$store.dispatch('tune/getTuneList');
  },
  methods: {
    // this.s
  },
  filters: {
    capitalize(val) { 
     return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.has-recording {
  border: 2px solid var(--v-primary-base);
}
.v-card { 
  transition: transform 0.2s ease-in-out;
}
.v-card:hover {
  transform: scale(1.1);
    .v-image__image--cover { 
      // transform: scale(1.1);
    }
}
</style>